/**
 * Padrão de nome de cliente (a mesma regra do banco: public.format_person_name):
 *  - primeira letra de cada palavra em maiúscula, o resto em minúscula ("SIMONE GRANO MONSO" -> "Simone Grano Monso");
 *  - partículas em minúscula quando não abrem o nome (de, da, do, das, dos, du, di, e): "zakat distribuidora DE cosmeticos" ->
 *    "Zakat Distribuidora de Cosmeticos";
 *  - maiúscula depois de apóstrofo e hífen ("d'or" -> "D'Or", "ana-clara" -> "Ana-Clara");
 *  - siglas de empresa: S.A., Ltda (e ME/EPP/MEI no fim) e numerais romanos II/III/IV.
 */
const PARTICLES = new Set(['de', 'da', 'do', 'das', 'dos', 'du', 'di', 'e']);

const capitalizeSegments = (word: string): string =>
  word
    .replace(/’/g, "'")
    .split(/(['-])/)
    .map((part) => (part === "'" || part === '-' ? part : part.charAt(0).toLocaleUpperCase('pt-BR') + part.slice(1)))
    .join('');

export const formatNameBR = (value: string | null | undefined): string => {
  const words = String(value ?? '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('pt-BR').split(' ');
  if (words.length === 0 || words[0] === '') return '';
  const last = words.length - 1;
  return words
    .map((word, i) => {
      if (i > 0 && PARTICLES.has(word)) return word;
      if (i > 0 && ['s.a.', 's.a', 's/a'].includes(word)) return 'S.A.';
      if (i === last && i > 0 && ['me', 'epp', 'mei'].includes(word)) return word.toUpperCase();
      if (i === last && i > 0 && (word === 'ltda' || word === 'ltda.')) return word === 'ltda' ? 'Ltda' : 'Ltda.';
      if (i > 0 && ['ii', 'iii', 'iv'].includes(word)) return word.toUpperCase();
      return capitalizeSegments(word);
    })
    .join(' ');
};
